import nexparkAnalyticsThumbnailUrl from '../../../assets/services/1_thumbnail.svg';
import nexparkAnalyticsUrl from '../../../assets/services/1.svg';

import priorityParkingThumbnailUrl from '../../../assets/services/2_thumbnail.svg';
import priorityParkingUrl from '../../../assets/services/2.svg';

import nexparkThumbnailUrl from '../../../assets/services/3_thumbnail.svg';
import nexparkUrl from '../../../assets/services/3.svg';

import nexresponseThumbnailUrl from '../../../assets/services/nexResponse_icon.svg';
import nexresponseUrl from '../../../assets/services/nexResponse_logo.svg';

import { ConnectedServiceType } from '../../../model';

const getServiceThumbnailIcon = (serviceId: number): string => {
  switch (serviceId) {
    case ConnectedServiceType.UmojoAnalytics:
      return nexparkAnalyticsThumbnailUrl;
    case ConnectedServiceType.NexCity:
      return priorityParkingThumbnailUrl;
    case ConnectedServiceType.NexPark:
      return nexparkThumbnailUrl;
    case ConnectedServiceType.NexResponse:
      return nexresponseThumbnailUrl;
    default:
      return nexparkAnalyticsThumbnailUrl;
  }
};

const getServiceIcon = (serviceId: number): string => {
  switch (serviceId) {
    case ConnectedServiceType.UmojoAnalytics:
      return nexparkAnalyticsUrl;
    case ConnectedServiceType.NexCity:
      return priorityParkingUrl;
    case ConnectedServiceType.NexPark:
      return nexparkUrl;
    case ConnectedServiceType.NexResponse:
      return nexresponseUrl;
    default:
      return nexparkAnalyticsUrl;
  }
};

export const connectedServiceIconService = {
  getServiceThumbnailIcon,
  getServiceIcon,
};
